type WithDepartment = {
  department?: string[];
};

export function filterByDepartment<T extends WithDepartment>(
  items?: T[],
  departmentId?: string
): T[] {
  return (items ?? []).filter(
    ({ department }) =>
      !departmentId || !department?.length || department.includes(departmentId)
  );
}
